import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  date: Types.Scalars['Date']['input'];
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly restrictions: { readonly __typename?: 'AccountsRestriction', readonly projectCreationRestricted: boolean }, readonly companies: ReadonlyArray<{ readonly __typename?: 'AccountsCompany', readonly id: string, readonly uuid: string, readonly name: string, readonly isLaunched: boolean, readonly tags: ReadonlyArray<{ readonly __typename?: 'AccountsTag', readonly id: string, readonly name: string, readonly category: { readonly __typename?: 'AccountsCategory', readonly id: string, readonly name: string, readonly tags: ReadonlyArray<{ readonly __typename?: 'AccountsTag', readonly id: string, readonly name: string }> } }>, readonly lastChecks: ReadonlyArray<{ readonly __typename?: 'YalperCheck', readonly found: number, readonly sensor: { readonly __typename?: 'YalperSensor', readonly id: string, readonly name: string } }>, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly id: string, readonly lastError?: string | null, readonly provider: Types.OauthProvider, readonly isValid: boolean }>, readonly stats: ReadonlyArray<{ readonly __typename?: 'YalperStat', readonly state: Types.YalperStatsState, readonly platform: Types.YalperPlatform }>, readonly sensorExclusions: ReadonlyArray<{ readonly __typename?: 'YalperSensorExclusion', readonly id: string, readonly sensorName: string }>, readonly sensorGroups: { readonly __typename?: 'AccountsCompanySensorGroups', readonly red: ReadonlyArray<string>, readonly yellow: ReadonlyArray<string>, readonly gray: ReadonlyArray<string> } }> } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($date: Date!) {
  currentUser {
    restrictions {
      projectCreationRestricted
    }
    companies {
      id
      uuid
      name
      isLaunched
      tags {
        id
        name
        category {
          id
          name
          tags {
            id
            name
          }
        }
      }
      lastChecks {
        found
        sensor {
          id
          name
        }
      }
      tokens {
        id
        lastError
        provider
        isValid
      }
      stats(date: $date) {
        state
        platform
      }
      sensorExclusions {
        id
        sensorName
      }
      sensorGroups {
        red
        yellow
        gray
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;